import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageContainer from '../../../layouts/PageContainer';
import PageHeader from '../../../components/Nav/PageHeader';
import RouterForm from '../../../components/Config/RouterForm';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const normalizeMac = (raw = '') =>
  raw
    .toUpperCase()
    .replace(/[^0-9A-F]/g, '')                // keep hex only
    .match(/.{1,2}/g)?.join(':') || '';        // re-insert :

const computeRouterName = (mac) => (mac ? `OPENFI-${normalizeMac(mac)}` : 'OPENFI-');

export default function NewRouterPage() {
  const navigate = useNavigate();

  const handleSave = async (payload) => {
    // MAC is required
    const mac = normalizeMac(payload.mac || '');
    if (!mac) {
      return { ok: false, message: 'MAC address is required.' };
    }

    // Force the name to our computed value
    const forced = {
      ...payload,
      mac,
      name: computeRouterName(mac),
    };
    const server_response = await ajaxConfig.createRouter(forced);
    
    if (server_response.status === 'OK') {
      navigate('/settings/routers', {
        state: { flash: { type: 'success', msg: server_response.message || 'Router registered.' } },
      });
      return { ok: true };
    }
    return { ok: false, message: server_response.message || 'Failed to register router.' };
  };

  return (
    <PageContainer>
      <PageHeader
        title="Register Router"
        breadcrumb={
          <>
            <li className="breadcrumb-item"><Link to="/settings">Settings</Link></li>
            <li className="breadcrumb-item"><Link to="/settings/routers">Routers</Link></li>
            <li className="breadcrumb-item active">New</li>
          </>
        }
      />

      <div className="row mb-3">
        <div className="col-12">
          <div className="alert alert-info mb-0">
            Register routers by vendor type. The router <strong>Name</strong> is auto–generated as <code>OPENFI-&lt;MAC&gt;</code>.
            Please enter a valid <strong>MAC address</strong> for bridge-hotspot interface.
          </div>
        </div>
      </div>

      <RouterForm
        editingId={null}
        // Show an initial name placeholder and make the field read-only (see RouterForm notes below)
        initialValues={{ name: 'OPENFI-', mac: '' }}
        readOnlyFields={['name']}
        requiredFields={['mac']}
        onDeriveName={(mac) => computeRouterName(mac)}
        onSubmit={handleSave}
      />
    </PageContainer>
  );
}
